import { usePreference as usePreferenceMain } from './hooks';
import { useNotificationPreference } from './notifications-app/use-notification-preferences';

export {
  usePrefBootstrap,
  usePreferenceStatus,
  usePreferenceLoadingStatus,
  useInitializePreferences,
  useLazyPreferenceQuery,
} from './hooks';
export { usePreferenceStore, preferenceActions } from './store';
export { updatePreferenceValue } from './hooks/use-preference';
export { shouldLazyLoad, getStickyNotePrefKey } from './constants';
export type { PreferenceKey, PreferenceDict, StoredPreference, PreferenceState } from './types';
export { DEFAULT_PREFERENCES } from './DEFAULTS';
export {
  requestUserPreferencesSync,
  useNotificationPreference,
  userPreferencesActions,
} from './notifications-app/use-notification-preferences';

export const usePreference =
  window.shell?.isShell && window.shell?.context === 'alerts' ? useNotificationPreference : usePreferenceMain;
